import React from 'react'
import HomePart1 from "./HomePart1";
import Navbar from "../Navbar/Navbar.tsx";
 
const HomePage = () => {
  return (
    <>
        <Navbar/>
        <HomePart1/>
        {/* <Footer1/>
        <Footerlast/> */}
    </>
  )
}

export default HomePage
